// extracted by mini-css-extract-plugin
export default {"section":"Advantages_section__HYyXA","container":"Advantages_container__v6nOI","heading":"Advantages_heading__ZS+jh","contentWrapper":"Advantages_contentWrapper__r1RAN"};